import React from "react";
import { connect } from "react-redux";

import { RootState } from "../../state";
import { ScreenSize } from "../utils/media";

export interface ScreenSizeProps {
  screenSize: ScreenSize;
}
interface RenderProps extends ScreenSizeProps {
  children: (props: ScreenSizeProps) => React.ReactNode;
}

const WithScreenSize: React.SFC<RenderProps> = ({ children: render, screenSize }) => {
  const rendered = render({ screenSize });
  return React.isValidElement(rendered) ? rendered : null;
};

function mapStateToProps(state: RootState): ScreenSizeProps {
  return {
    screenSize: state.media.screenSize,
  };
}

export default connect(mapStateToProps)(WithScreenSize);



// WEBPACK FOOTER //
// ./frontend/src/common/components/WithScreenSize.tsx